import CXMApiClient from "../CXMApiClient";

function initialLoad() {
  return {
    VideoLibraryModalInfo: {
      showModal: false,
      data: null
    },
    SelectedVideos: null
  };
}

const state = initialLoad();

const actions = {
  async getVideoSubCategories(context) {
    let response = await new CXMApiClient().ProcessRequest(
      "get",
      "/cxp/video/subcategory"
    );
    return response ? response : null;
  },
  async loadDealerVideos(context, request) {
    let cxmApiClient = new CXMApiClient();
    let response = await cxmApiClient.ProcessRequest(
      "POST",
      "/cxp/video/search",
      request
    );
    return response && response.data ? response.data : null;
  },
  loadVideoData: function(context, request) {
    return new Promise((resolve, reject) => {
      let client = new CXMApiClient();
      client
        .ProcessRequest(
          "post",
          "/cxp/video/dashboard/slideout",
          request.filter,
          request.scope
        )
        .then(response => {
          if (response && response.data.successful) {
            resolve(response.data);
          } else {
            reject(response);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  async getVideoDashboardCount(context, requestPayload) {
    let cxmApiClient = new CXMApiClient();
    return await cxmApiClient.ProcessRequest("POST", `/cxp/video/dashboard/count`, requestPayload)
      .catch(err => err.response);
  },
  updateVideoLibraryModalInfo(context, data) {
    context.commit("updateVideoLibraryModalInfo", data);
  },
  setSelectedVideos(context, videos) {
    context.commit("setSelectedVideos", videos);
  },
};
const mutations = {
  updateVideoLibraryModalInfo(state, data) {
    state.VideoLibraryModalInfo = data;
  },
  setSelectedVideos(state, data) {
    state.SelectedVideos = data;
  },
};

const getters = {
  SelectedVideos: function() {
    return state.SelectedVideos;
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/VideoLibrary.js